import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ProductItem } from './';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

function List({ children }) {
  return (
    <StyledList>
      {children.map((value, index) => (
        <ProductItem key={index}>{value}</ProductItem>
      ))}
    </StyledList>
  );
}

const StyledList = styled.ul`
  display: block;
  list-style: none;
`;

List.propTypes = propTypes;
export default List;
